import { FunctionComponent } from 'react'
import CalendarMobile from './calendarMobile/calendarMobile.tsx'
import Desktop from '@/modules/desktopMobile/desktop.tsx'
import Mobile from '@/modules/desktopMobile/mobile.tsx'
import CalendarDesktop from './calendarDesktop/calendarDesktop.tsx'
import CalendarStaff from './calendarStaff/calendarStaff.tsx'
import { PlanningRights, PlanningTabsState } from '@/hooks/usePlanningRights.ts'
import { Daycare } from '@/types/Daycare.ts'
import { EventCalendar } from '@/types/Calendar.ts'
import { StaffWithLinks } from '@/types/Staff.ts'
import { DateSelectArg, EventClickArg } from '@fullcalendar/core'
import { DateClickArg } from '@fullcalendar/interaction'
import { FetchPlanningDataProps } from '../hooks/usePlanningSlots.ts'

interface CalendarProps {
    planningTabs: PlanningTabsState
    planningRights: PlanningRights
    fetchData: (props: FetchPlanningDataProps) => void
    currentDaycare: Daycare
    filteredCalendarEvents: EventCalendar[]
    refetchData: (isGlobalPlanning?: boolean) => void
    sortedStaffs: StaffWithLinks[]
    isMobile: boolean
    currentView: string
    setCurrentView: (view: string) => void
    hiddenDays: number[]
    handleSelectWeb: (arg: DateSelectArg) => void
    handleEventClickArg: (info: EventClickArg) => void
    handleEventClick: (info: EventCalendar) => void
    handleSelectMobile: (info: DateClickArg) => void
}

const Calendar: FunctionComponent<CalendarProps> = ({
    planningTabs,
    planningRights,
    fetchData,
    currentDaycare,
    filteredCalendarEvents,
    refetchData,
    sortedStaffs,
    isMobile,
    currentView,
    setCurrentView,
    hiddenDays,
    handleSelectWeb,
    handleEventClickArg,
    handleEventClick,
    handleSelectMobile
}: CalendarProps) => {
    return planningTabs.isStaffTab ? (
        <CalendarStaff
            fetchData={fetchData}
            currentDaycare={currentDaycare}
            calendarEvents={filteredCalendarEvents}
            refetchData={() => refetchData(false)}
            staffsListData={sortedStaffs}
            isMobile={isMobile}
            currentView={currentView}
        />
    ) : (
        <>
            <Desktop>
                <CalendarDesktop
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                    fetchData={fetchData}
                    currentDaycare={currentDaycare}
                    isParent={planningRights.isParent}
                    calendarEvents={filteredCalendarEvents}
                    hiddenDays={hiddenDays}
                    handleSelect={handleSelectWeb}
                    handleEventClickArg={handleEventClickArg}
                    handleEventClick={handleEventClick}
                    isGlobalPlanning={planningTabs.isGlobalTab}
                />
            </Desktop>
            <Mobile>
                <CalendarMobile
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                    fetchData={fetchData}
                    currentDaycare={currentDaycare}
                    isParent={planningRights.isParent}
                    calendarEvents={filteredCalendarEvents}
                    hiddenDays={hiddenDays}
                    handleSelect={handleSelectMobile}
                    handleEventClickArg={handleEventClickArg}
                    handleEventClick={handleEventClick}
                    isGlobalPlanning={planningTabs.isGlobalTab}
                />
            </Mobile>
        </>
    )
}

export default Calendar
